import { toast } from 'sonner';

export interface StoreNotice {
    type: 'ok' | 'err';
    text: string;
}

export function notify(notice: StoreNotice): void {
    if (notice.type === 'ok') toast.success(notice.text);
    else toast.error(notice.text);
}

export function notifyOk(text: string): void {
    toast.success(text);
}

export function notifyErr(text: string): void {
    toast.error(text);
}
